import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Organization } from '../../../common/models/organization.model';
import { SubHeader } from '../../../core/models/sub-header.model';
import { OrganizationFormComponent } from '../../../common/components/organization/components/organization-form.component';
import { SubHeaderService } from '../../../core/services/sub-header.service';
import { OrganizationService } from '../../../common/services/organization.service';
import { LoaderService } from '../../../common/services/loader.service';
import { AuthService } from '../../../services/auth.service';
import { LunaClaimTypes, LunaClaimValues } from '../../../models/user-identity.model';

@Component({
    selector: 'app-organization',
    templateUrl: './organization.component.html',
    standalone: false
})
export class OrganizationComponent implements OnInit {

    organization: Organization;
    displayLabel: boolean = this.authService.User.isInternal ? true : false;
    parentOrganization: Organization;

    subHeader: SubHeader;
    canEditOrg: boolean = false;  

  @ViewChild(OrganizationFormComponent, { static: true }) public _form: OrganizationFormComponent;

    constructor(public location: Location,
        public authService: AuthService,  
        public route: ActivatedRoute,
        public router: Router,
        public subHeaderService: SubHeaderService,
        public service: OrganizationService,
        public loader: LoaderService) {

        this.canEditOrg = this.authService.User.allClaims.filter(a => a.type == LunaClaimTypes.System && a.value == LunaClaimValues.CanEditOrganization).length > 0;
        let subHeaderButtons: any[] = [];

        subHeaderButtons.push({ name: "Cancel", method: () => this.cancel() });
        if (this.canEditOrg)
            subHeaderButtons.push({ name: "Save", method: () => this.save() });

        this.subHeader = new SubHeader({
            title: "Organization Information",
            buttons: subHeaderButtons
        });
    }

  ngOnInit() {
    this.loader.toggleLoader(false);
    this.subHeaderService.updateSubHeader(this.subHeader);
    this.organization = this.route.snapshot.data.organization;

    //If this org has a parent one, fetch it
      if (this.organization.isDbaName && this.organization.parentOrganizationId !== undefined
          && this.organization.parentOrganizationId !== null && this.organization.parentOrganizationId !== "") {
          this.service.getOrganization(this.organization.parentOrganizationId).subscribe(fetchedParentOrganization => {
              if (fetchedParentOrganization)
                this.parentOrganization = fetchedParentOrganization;
        })
    }
    if (!this.organization.departments) this.organization.departments = [];
  }

  addContact(): void {
    this.router.navigate(['admin', 'contact', 'add', true, this.organization.id])
  }

  cancel(): void {
    this.loader.toggleLoader(true);
    this.location.back();
  }

  save(): void {

    if (this._form.isValid) {
        this.loader.toggleLoader(true);

        this.service.save(this.organization).subscribe(response => {
            
            if (this.organization.isDbaName) {
                this.service.save(this.parentOrganization).subscribe(response => {
                    this.location.back();
                });
            }
            else { this.location.back(); }
        });
    }
  }

}
